import { render, staticRenderFns } from "./trialCustomers.vue?vue&type=template&id=efe0fd46&scoped=true"
import script from "./trialCustomers.vue?vue&type=script&lang=js"
export * from "./trialCustomers.vue?vue&type=script&lang=js"
import style0 from "./trialCustomers.vue?vue&type=style&index=0&id=efe0fd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe0fd46",
  null
  
)

export default component.exports